import axios from 'axios';

const workerUrl = process.env.REACT_APP_CLOUD_WORKER_URL;
const authToken = process.env.REACT_APP_CLOUD_WORKER_SECRET;

export const uploadImage = async (imageFile) => {
  const imageFormData = new FormData();
  imageFormData.append('image', imageFile);

  const response = await axios.put(
    `${workerUrl}/${imageFile.name}`,
    imageFile,
    {
      headers: {
        'Authorization': `Bearer ${authToken}`,
        'Content-Type': imageFile.type,
      },
    }
  );

  if (response.status !== 200) {
    throw new Error('Failed to upload image');
  }

  return `${workerUrl}/${imageFile.name}`;
};

export const deleteImage = async (imageName) => {
  const response = await axios.delete(`${workerUrl}/${imageName}`, {
    headers: {
      'Authorization': `Bearer ${authToken}`,
    },
  });

  if (response.status !== 200) {
    throw new Error('Failed to delete image');
  }

  return response;
};